<div class="retry b-style">
  <div class="retry__image-block">
    <img class="retry__image" src="./assets/img/icons/i-retry.svg" width="200" height="150" alt="Oops, something went wrong">
  </div>
  <h3 class="retry__title" translate="retry.title"></h3>
  <p class="retry__text" translate="retry.description"></p>
  <div class="actions-wrapper actions-wrapper--column">
    <button class="button" translate="retry.retry-link" (click)="reload()"></button>
    <ng-container *ngIf="isLoggedIn">
       <a class="link button--link" translate="retry.proceed-to-personal-area" routerLink="/dashboard"></a>
    </ng-container>
  </div>
</div>
